import dayjs from 'dayjs';
import {z} from 'zod';

export const WEEK_DAYS = [
  {value: 'Monday', label: 'Lundi'},
  {value: 'Tuesday', label: 'Mardi'},
  {value: 'Wednesday', label: 'Mercredi'},
  {value: 'Thursday', label: 'Jeudi'},
  {value: 'Friday', label: 'Vendredi'},
  {value: 'Saturday', label: 'Samedi'},
  {value: 'Sunday', label: 'Dimanche'}
];

export function formatSelectedDays(daysObj) {
  if (!daysObj) return '';

  const selected = WEEK_DAYS.filter(d => daysObj[d.value]);

  if (selected.length === 0) return '';

  // all days
  if (selected.length === WEEK_DAYS.length) {
    return 'tous les jours de la semaine.';
  }

  // single day
  if (selected.length === 1) {
    return `le ${selected[0].label.toLowerCase()}.`;
  }

  // check if consecutive
  const isConsecutive = selected.every((day, i) => {
    if (i === 0) return true;
    const prevIndex = WEEK_DAYS.findIndex(d => d.value === selected[i - 1].value);
    const currentIndex = WEEK_DAYS.findIndex(d => d.value === day.value);
    return currentIndex === prevIndex + 1;
  });

  if (isConsecutive) {
    return `du ${selected[0].label.toLowerCase()} au ${selected[selected.length - 1].label.toLowerCase()}.`;
  }

  // fallback: list
  if (selected.length === 2) {
    return `${selected[0].label.toLowerCase()} et ${selected[1].label.toLowerCase()}.`;
  }

  return `${selected
    .slice(0, -1)
    .map(d => d.label.toLowerCase())
    .join(', ')} et ${selected[selected.length - 1].label.toLowerCase()}.`;
}

export const plannedUpdateSchema = z.object({
  enabled: z.boolean(),
  localTimeZoneId: z.string(),
  weekdays: z
    .object(
      WEEK_DAYS.reduce((acc, day) => {
        acc[day.value] = z.boolean();
        return acc;
      }, {})
    )
    .refine(val => Object.values(val).some(Boolean), {
      message: 'Veuillez sélectionner au moins un jour.'
    }),
  executionTimes: z
    .array(
      z.object({
        time: z
          .any() // accept any input first
          .nullable()
          .transform(val => (val ? val.toDate() : null)) // convert Dayjs → Date
          .refine(val => val === null || val instanceof Date, {
            message: 'Heure invalide'
          })
      })
    )
    .refine(times => times.some(t => t.time !== null), {
      message: 'Veuillez ajouter au moins une heure.'
    })
});

export const deserializePlannedUpdate = api => {
  // Convert API days array to form weekdays object
  const weekdays = WEEK_DAYS.reduce((acc, day) => {
    acc[day.value] = (api.days || []).includes(day.value);
    return acc;
  }, {});

  return {
    localTimeZoneId: api.localTimeZoneId,
    enabled: api.enabled ?? true,
    weekdays,
    executionTimes: (api.times || []).map(time => ({time: dayjs(time, 'HH:mm')}))
  };
};
